/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {
  NgModule,
  Directive,
  Renderer2,
  ElementRef,
  QueryList,
} from '@angular/core';
import {MdCommonModule} from '../common-behaviors/common-module';
/**
 * Shared directive to count lines inside a text area, such as a list item.
 * Line elements can be extracted with a \@ContentChildren(MdLine) query, then
 * counted by checking the query list's length.
 */
export class MdLine {static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[md-line], [mat-line], [mdLine], [matLine]',
  host: {'class': 'mat-line'}
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdLine_tsickle_Closure_declarations() {
/** @type {?} */
MdLine.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdLine.ctorParameters;
}

/**
 * Helper that takes a query list of lines and sets the correct class on the host.
 * \@docs-private
 */
export class MdLineSetter {
/**
 * @param {?} _lines
 * @param {?} _renderer
 * @param {?} _element
 */
constructor(private _lines: QueryList<MdLine>,
private _renderer: Renderer2,
private _element: ElementRef) {
    this._setLineClass(this._lines.length);

    this._lines.changes.subscribe(() => {
      this._setLineClass(this._lines.length);
    });
  }
/**
 * @param {?} count
 * @return {?}
 */
private _setLineClass(count: number): void {
    this._resetClasses();
    if (count === 2 || count === 3) {
      this._setClass(`mat-${count}-line`, true);
    } else if (count > 3) {
      this._setClass(`mat-multi-line`, true);
    }
  }
/**
 * @return {?}
 */
private _resetClasses(): void {
    this._setClass('mat-2-line', false);
    this._setClass('mat-3-line', false);
    this._setClass('mat-multi-line', false);
  }
/**
 * @param {?} className
 * @param {?} isAdd
 * @return {?}
 */
private _setClass(className: string, isAdd: boolean): void {
    if (isAdd) {
      this._renderer.addClass(this._element.nativeElement, className);
    } else {
      this._renderer.removeClass(this._element.nativeElement, className);
    }
  }

}

function MdLineSetter_tsickle_Closure_declarations() {
/** @type {?} */
MdLineSetter.prototype._lines;
/** @type {?} */
MdLineSetter.prototype._renderer;
/** @type {?} */
MdLineSetter.prototype._element;
}

export class MdLineModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [MdCommonModule],
  exports: [MdLine, MdCommonModule],
  declarations: [MdLine],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdLineModule_tsickle_Closure_declarations() {
/** @type {?} */
MdLineModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdLineModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
